import { DATA } from '../../../config/data';

export const performanceChartConfiguration = {
  seriesDefinitions: [
    {
      name: DATA.TEMP.CURRENT.LABEL,
      color: DATA.TEMP.CURRENT.COLOR,
      type: 'spline',
      opacity: 1,
      yAxis: 0,
      dataGrouping: { approximation: 'high' },
    },
    {
      name: DATA.TEMP.LOWER_BOUND.LABEL,
      color: DATA.TEMP.LOWER_BOUND.COLOR,
      type: 'spline',
      opacity: 0.4,
      yAxis: 0,
      dataGrouping: { approximation: 'high' },
      dashStyle: 'ShortDash',
    },
    // {name: "Target", color: "#16B364", type: "spline", opacity: 1, yAxis: 0, dataGrouping: { approximation: "high"}},
    {
      name: DATA.TEMP.UPPER_BOUND.LABEL,
      color: DATA.TEMP.UPPER_BOUND.COLOR,
      type: 'spline',
      opacity: 0.4,
      yAxis: 0,
      dataGrouping: { approximation: 'high' },
      dashStyle: 'ShortDash',
    },
    {
      name: DATA.TEMP.OUTSIDE.LABEL,
      color: DATA.TEMP.OUTSIDE.COLOR,
      type: 'spline',
      opacity: 1,
      yAxis: 0,
      dataGrouping: { approximation: 'high' },
      visible: false,
    },
  ],

  plotBandColors: {
    C: DATA.ACTIVITY.COOLING.BAND,
    H: DATA.ACTIVITY.HEATING.BAND,
    F: DATA.ACTIVITY.FAN.BAND,
  },

  defaultLiveZoom: 3,
};
